import axios from "axios";

//In order to have this project access the Dev API, create a file in the project root named '.env.development.local' and add the following line to it:
//REACT_APP_API_URL = 'https://app-verisma-dev.azurewebsites.net/api/api/'
//This file is listed in .gitignore and will not be included with push requests
const baseURL = process.env.REACT_APP_API_URL ?? "/api/api/";

export const documentURL = baseURL + "documents/"

const headers = {
  'Cache-Control': 'no-cache',
  'Content-Type': 'application/json',
  'refreshaudittrail': '0'
}

export const ApiUrl = () => { return baseURL; }

export function post<T = any>(url: string, data?: any, customHeaders: any = headers) {
    return axios.post<T>(baseURL + url, data, { headers: customHeaders, withCredentials: true });
}

export function postProgress<T = any>(
    url: string,
    data?: any,
    customHeaders: any = headers,
    onUploadProgress?: (progressEvent: any) => void
) {
    return axios.post<T>(
        baseURL + url,
        data,
        {
            headers: customHeaders,
            onUploadProgress: onUploadProgress,
            withCredentials: true,
        },
    );
}

export function get<T = any>(url: string) {
    return axios.get<T>(baseURL + url, { headers, withCredentials: true });
}

export function deleteRequest<T = any>(url: string, data?: any) {
    return axios.delete<T>(baseURL + url, { headers, data, withCredentials: true });
}

export function putRequest<T = any>(url: string, data: any) {
    return axios.put<T>(baseURL + url, data, { headers, withCredentials: true });
}

export function patchRequest<T = any>(url: string, data: any) {
    return axios.patch<T>(baseURL + url, data, { headers, withCredentials: true });
}

export function getWithoutBaseURL<T = any>(url: string) {
    return axios.get<T>(url, { headers, withCredentials: true });
}